import { BACKEND_URL, FALLBACK_LANGUAGE } from "@konova/config";
import axios, { CreateAxiosDefaults } from 'axios';

export const createAxiosInstance = (config: CreateAxiosDefaults = {}, language = FALLBACK_LANGUAGE) =>
  axios.create({
    withCredentials: true,
    baseURL: BACKEND_URL,
    headers: {
      common: {
        'Accept-Language': encodeURI(language)
      }
    },
    ...config,
  });

const globInstance = createAxiosInstance({}, window.location.pathname.split('/').filter(Boolean)[0]);

export const getAxios = () => globInstance;